import { TypeMediaReleaseArticleContactWithoutUnresolvableLinksResponse } from 'contentful-types'
import { Box, FlexGrid, Link, Spacer, Typography } from '@telus-uds/components-web'

export const getArticleContacts = (contacts: TypeMediaReleaseArticleContactWithoutUnresolvableLinksResponse[]) => {
  return contacts?.map((contact, i) => {
    const offset = i % 2 == 0 ? 2 : 0

    return (
      <FlexGrid.Col key={contact.sys.id} xs={12} sm={12} md={12} lg={4} xl={4} lgOffset={offset} xlOffset={offset}>
        <Box>
          <Typography variant={{ size: 'h4' }} heading="h4">
            {contact.fields.heading}
          </Typography>
          <Spacer space={3} />
          <Typography variant={{ bold: true }}>{contact.fields.name}</Typography>
          <Typography>{contact.fields.department}</Typography>
          <Typography>{contact.fields.phone}</Typography>
          <Spacer space={3} />
          <Link href={contact.fields.email}>{contact.fields.email}</Link>
        </Box>
        <Spacer space={5} />
      </FlexGrid.Col>
    )
  })
}
